import styled from '@emotion/styled';
import { ob, fadeIn } from '../../onboardingV2.tokens';

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 1fr;
    gap: 12px;
    pointer-events: ${({ locked }) => (locked ? 'none' : 'auto')};
`;

export const Card = styled.button`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 112px;
    padding: 16px 10px;
    border: ${({ isSelected }) =>
        isSelected ? `2px solid ${ob.color.brand}` : `1.5px solid ${ob.color.borderSubtle}`};
    border-radius: ${ob.radius.lg};
    background: ${({ isSelected }) => (isSelected ? ob.color.lime50 : ob.color.surface)};
    font-family: ${ob.font.body};
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition:
        border-color ${ob.motion.fast},
        background ${ob.motion.fast},
        transform ${ob.motion.fast};
    animation: ${({ appear }) => (appear ? fadeIn : 'none')} ${ob.motion.base} ease-out;

    ${ob.hover} {
        &:hover {
            border-color: ${({ isSelected }) =>
                isSelected ? ob.color.brand : ob.color.borderHover};
        }
        &:hover > span:first-of-type {
            background: ${({ isSelected }) => (isSelected ? ob.color.lime : ob.color.lime200)};
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }

    &:active {
        transform: scale(0.98);
    }

    ${ob.reducedMotion} {
        animation: none;
        transition: none;
        &:active {
            transform: none;
        }
    }
`;

export const IconCircle = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${({ isSelected }) => (isSelected ? ob.color.lime : ob.color.lime100)};
    color: ${ob.color.brand};
    transition: background ${ob.motion.fast};

    i {
        font-size: 26px;
        line-height: 1;
    }
`;

export const CardLabel = styled.span`
    font-size: 15px;
    line-height: 1.3;
    font-weight: 600;
    color: ${ob.color.brand};
    text-align: center;
    text-wrap: balance;
`;

export const Check = styled.span`
    position: absolute;
    top: 8px;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: ${ob.color.brand};
    color: ${ob.color.surface};

    i {
        font-size: 14px;
    }
`;

export const Toggle = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    min-height: 48px;
    margin-top: 12px;
    border: 1.5px solid ${ob.color.borderSubtle};
    border-radius: ${ob.radius.pill};
    background: ${ob.color.surface};
    font-family: ${ob.font.body};
    font-size: 15px;
    font-weight: 600;
    color: ${ob.color.brand};
    cursor: pointer;

    i {
        font-size: 20px;
        transition: transform ${ob.motion.slow};
        transform: rotate(${({ expanded }) => (expanded ? '180deg' : '0')});
    }

    ${ob.hover} {
        &:hover {
            border-color: ${ob.color.borderHover};
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }

    ${ob.reducedMotion} {
        i {
            transition: none;
        }
    }
`;
